import MuiLink from '@mui/material/Link';
import React, {forwardRef} from 'react';
import {Link as RouterLink} from 'react-router';

const Link = forwardRef((props, ref) => {
  return <MuiLink ref={ref} component={RouterLink} {...props} />;
});

export default Link;
